import React from 'react'
import styled, { css } from 'styled-components'
import { color, breakpoint, transition, opacity } from '@configs/utilities'
import { Link } from 'gatsby-plugin-react-intl'
import angle from '@assets/images/navbar/angle.svg'
import { useLocation } from '@reach/router'
import NavbarMegaMenu from '@components/layouts/default/navbar/NavbarMegaMenu'

const NavItemsDesktop = ({ intl, data }) => {
  const location = useLocation().pathname.split('/').pop()

  return (
    <NavItemsDesktopWrapper>
      {data.map((item, index) => {
        return (
          <div key={index}>
            {!item.node.submenu ? (
              <NavbarItem className="mainLinks">
                <Link to={item.node.path} activeClassName="activeNavbarLink">
                  {intl.formatMessage({ id: item.node.text })}
                </Link>
              </NavbarItem>
            ) : !item.node.megaMenu ? (
              <NavbarItem>
                <SubmenuParent className="mainLinks">
                  <span
                    className={
                      item.node.submenu.some((item) => {
                        return item.path.includes(location)
                      }) && location !== ''
                        ? 'submenuParentText activeNavbarLink'
                        : 'submenuParentText'
                    }
                  >
                    {intl.formatMessage({ id: item.node.text })}
                  </span>
                </SubmenuParent>
                <img src={angle} className="angle" alt="IdeaBuddy Logo" />
                <NavbarSubmenu>
                  {item.node.submenu.map((item, index) => {
                    return (
                      <SubmenuLinkWrapper key={index} className={item.borderBottom ? `addBorder` : ``}>
                        {item.path.includes('https') ? (
                          <a href={item.path} target="_self" rel="noopener noreferrer">
                            {intl.formatMessage({ id: item.text })}
                          </a>
                        ) : (
                          <Link to={item.path} activeClassName="activeSubmenuLink">
                            {intl.formatMessage({ id: item.text })}
                          </Link>
                        )}
                      </SubmenuLinkWrapper>
                    )
                  })}
                </NavbarSubmenu>
              </NavbarItem>
            ) : (
              <NavbarMegaItem>
                <SubmenuParent className="mainLinks">
                  <span
                    className={
                      item.node.submenu.some((item) => {
                        return item.path.includes(location)
                      }) && location !== ''
                        ? 'submenuParentText activeNavbarLink'
                        : 'submenuParentText'
                    }
                  >
                    {intl.formatMessage({ id: item.node.text })}
                  </span>
                </SubmenuParent>
                <img src={angle} className="angle" alt="IdeaBuddy Logo" />

                <MegaMenu>
                  <NavbarMegaMenu />
                </MegaMenu>
              </NavbarMegaItem>
            )}
          </div>
        )
      })}
    </NavItemsDesktopWrapper>
  )
}

export default NavItemsDesktop

const NavItemsDesktopWrapper = styled.div`
  display: none;
  width: 55%;
  color: ${color.font};

  @media screen and (min-width: ${breakpoint.lg}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 45%;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    width: 55%;
    justify-content: flex-start;
  }

  a {
    color: ${color.font};
    white-space: nowrap;
    transition: ${transition.default};
  }

  /* --------------------------  ACTIVE --------------------------- */
  .activeNavbarLink {
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 3px;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      transition: ${transition.default};
      background-color: ${color.blue};
    }
  }

  .activeSubmenuLink {
    transition: ${transition.default};
    color: ${color.blue};
  }

  .addBorder {
    border-bottom: 0.5px solid ${color.silverDark};
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
`

const SubmenuParent = styled.div`
  margin-right: 5px;
  line-height: 50px;

  .submenuParentText {
    transition: ${transition.default};
  }
`

const NavbarSubmenu = styled.div`
  display: none;
  opacity: 0;
  position: absolute;
  top: 45px;
  left: -20px;
  flex-direction: column;
  padding: 10px;
  background: ${color.white};
  border-radius: 8px;
  transform: translateX(100%);
  transition: transform 0.3s ease-in;
  cursor: default;
  border: 1px solid ${color.silverDark};
`

const SubmenuLinkWrapper = styled.div`
  width: 100%;
  line-height: 30px;

  a {
    color: ${color.font};
    line-height: 30px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    padding: 3px 50px 3px 10px;
    transition: ${transition.default};
    font-weight: 400;

    &:hover {
      opacity: ${opacity.default};
      background: #deebff;
      color: ${color.blue};
    }
  }
`

const MegaMenu = styled.div`
  display: none;
  opacity: 0;
  position: absolute;
  top: 45px;
  left: -20px;
  flex-direction: column;
  padding: 10px;
  background: ${color.white};
  border-radius: 8px;
  transform: translateX(100%);
  transition: transform 0.3s ease-in;
  cursor: default;
  border: 1px solid ${color.silverDark};
  min-width: 750px;
`

const sharedLinkStyles = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 50px;
  cursor: pointer;
  transition: ${transition.default};
  margin-right: 40px;

  @media screen and (min-width: ${breakpoint.lg}) {
    margin-right: 20px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    margin-right: 40px;
    font-size: 18px;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 3px;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    transition: ${transition.default};
  }

  &:hover::after {
    width: 100%;
    background-color: ${color.blue};
  }

  @keyframes showDropdown {
    from {
      clip-path: inset(0 70% 0 30%);
      transform: translateY(50px);
    }

    to {
      clip-path: inset(0 0 0 0);
      transform: translateY(0px);
      opacity: 1;
    }
  }
`

const NavbarItem = styled.div`
  ${sharedLinkStyles}
  &:hover {
    ${NavbarSubmenu} {
      display: flex;
      animation: showDropdown 0.3s forwards;
    }

    .angle {
      transform: rotate(-180deg);
      transition: ${transition.default};
    }
  }
`

const NavbarMegaItem = styled.div`
  ${sharedLinkStyles}
  &:hover {
    ${MegaMenu} {
      display: flex;
      animation: showDropdown 0.3s forwards;
    }

    .angle {
      transform: rotate(-180deg);
      transition: ${transition.default};
    }
  }
`
